import { Box } from "@mui/material";
import { ArtifactStyle } from "./VerficationArtifactsStyles";
import { useVerification } from "../../../../../context/Verification.context";
import TextUnAvailable from "./TextUnAvailable";

const TextResponse = ({ artifact }) => {
  const verification = useVerification();
  return <TextUnAvailable text={artifact?.text} es_text={artifact?.es_text} />;
};
export default TextResponse;
